import { render, staticRenderFns } from "./ShareQRDialog.vue?vue&type=template&id=82a2d0f2&scoped=true&"
import script from "./ShareQRDialog.vue?vue&type=script&lang=ts&"
export * from "./ShareQRDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82a2d0f2",
  null
  
)

export default component.exports